import {Component, Input} from '@angular/core';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DataService} from 'src/app/services/data.service';
import {DialogService} from 'src/app/services/dialog.service';

@Component({
  selector: 'app-enterprise-download-predictions',
  templateUrl: './download-predictions.component.html',
  styleUrls: ['./download-predictions.component.scss']
})
export class DownloadPredictionsComponent {
  inProgress = false;
  @Input() insightId;

  constructor(
    private trustiiService: TrustiiService,
    private dataservice: DataService,
    private dialogService: DialogService
  ) {
  }

  download(): void {
    this.inProgress = true;
    this.trustiiService.getInsightData(this.insightId).subscribe(
      (res) => {
        this.dataservice.downloadFile(res.data, res.columns, 'trustii-predictions-' + Date.now());
        this.inProgress = false;
      },
      (err) => {
        this.inProgress = false;
        this.dialogService.openAlertDialog(
          '350px',
          'Error during predictions download.',
          'ERROR',
          'Ok',
          'modal-warning'
        );
      }
    );
  }
}
